import React from 'react';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import environmentStore from '@di-shared/features/environment/environmentStore';
import VehicleInspectionEditReservationForm, {
  VehicleInspectionEditReservationStep,
} from '@di-shared/features/public-service/vehicle-inspection/reservation/VehicleInspectionEditReservationForm';
import useUrlQueryStore from '@shared/useUrlQueryStore';

export interface VehicleInspectionEditReservationPageProps {
  vin: string;
  reservationNumber: string;
}

const STEP_KEY = 's';

function VehicleInspectionEditReservationPage({vin, reservationNumber}: VehicleInspectionEditReservationPageProps): JSX.Element {
  const {t} = useInferableTranslation();
  const puid = environmentStore.getState().puid;

  const [stepStore, setStepStore] = useUrlQueryStore<{step: VehicleInspectionEditReservationStep}>(STEP_KEY, {
    step: VehicleInspectionEditReservationStep.STEP_2_PLACE,
  });

  function updateStep(step: VehicleInspectionEditReservationStep, isReplace: boolean) {
    // STEP_1_DISCOUNT, STEP_2_BEFORE_PLACE 의 경우, 스탭 내에서 번외 스탭같은 개념임. 여기서 이탈할때는 replace 하는것이 플로우상 정확
    setStepStore({step}, isReplace);
  }

  return (
    <VehicleInspectionEditReservationForm
      vin={vin}
      puid={puid}
      reservationNumber={reservationNumber}
      step={stepStore.step}
      updateStep={updateStep}
    />
  );
}

export default VehicleInspectionEditReservationPage;
